import type { OfferApi } from '@fourthwall/services/dist/OffersApiClient'
import { useAdminModeContext } from '@modules/App/providers/AdminModeProvider'
import { useOffersInfiniteQuery } from '@modules/Dashboard/hooks/useOffersInfiniteQuery'
import type { UseInfiniteQueryOptions } from '@tanstack/react-query'

import { getSamplesOffersQueryParams } from '../utils/getSamplesOffersQueryParams'

const size = 5

export const useSamplesInfiniteOffersQuery = (
  query?: string,
  options?: UseInfiniteQueryOptions<OfferApi.GetOffersResponse>,
) => {
  const adminMode = useAdminModeContext()
  const { offersInfiniteQuery } = useOffersInfiniteQuery(
    getSamplesOffersQueryParams({
      size,
      query,
      includeFulfillmentService: !adminMode?.isActive,
    }),
    {
      keepPreviousData: true,
      ...options,
    },
  )

  return {
    offersInfiniteQuery,
  }
}
